export default "__VITE_ASSET__9ae98ff8__"